import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="col00">
        <div class="heading01 type01">
            <h1>{{ 'questionCategory.Manage question categories' | translate }}</h1>
            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn add" ng-click="vm.addCategory()">{{ 'questionCategory.Add category' | translate }}</a>
        </div>
        <div class="alert alert-plain">
            <p>{{ 'questionCategory.Only 2nd or lower level categories can be linked to questions.' | translate }}</p>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'questionCategory.Name' | translate }}</a></th>
                        <th ng-class="vm.list.getSortClass('questionCount')"><a ng-click="vm.list.sortBy('questionCount')">{{ 'questionCategory.Question count' | translate }}</a></th>
                        <th>{{ 'questionCategory.Question pools' | translate }}</th>
                        <th ng-class="vm.list.getSortClass('status')"><a ng-click="vm.list.sortBy('status')">{{ 'questionCategory.Status' | translate }}</a></th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat-start="item in vm.list.items" ng-class="{status04: item.status === vm.FORMS_CATEGORY_QUESTION_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.questioncategories.edit({ id: item.id })">{{ item.activeI18n.name }}</td>
                        <td>{{ item.questionCount }}</td>
                        <td>{{ vm.getQuestionPools(item.questionPools) }}</td>
                        <td>{{ vm.FORMS_CATEGORY_QUESTION_ENUM.LABELS[item.status] }}</td>
                        <td class="actions">
                            <a class="btn add" ng-click="vm.addSubCategory(item.id)">{{ 'questionCategory.Add subcategory' | translate }}</a>
                            <a class="btn edit" ui-sref="authorized.forms.settings.questioncategories.edit({ id: item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deleteCategory(item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-start="l2item in item.childCategories" class="level02" ng-class="{status04: l2item.status === vm.FORMS_CATEGORY_QUESTION_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.questioncategories.edit({ id: l2item.id })">{{ l2item.activeI18n.name }}</td>
                        <td>{{ l2item.questionCount }}</td>
                        <td>{{ vm.getQuestionPools(l2item.questionPools) }}</td>
                        <td>{{ vm.FORMS_CATEGORY_QUESTION_ENUM.LABELS[l2item.status] }}</td>
                        <td class="actions">
                            <a class="btn add" ng-click="vm.addSubCategory(l2item.id)">{{ 'questionCategory.Add subcategory' | translate }}</a>
                            <a class="btn edit" ui-sref="authorized.forms.settings.questioncategories.edit({ id: l2item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deleteCategory(l2item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-start="l3item in l2item.childCategories" class="level03" ng-class="{status04: l3item.status === vm.FORMS_CATEGORY_QUESTION_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.questioncategories.edit({ id: l3item.id })">{{ l3item.activeI18n.name }}</td>
                        <td>{{ l3item.questionCount }}</td>
                        <td>{{ vm.getQuestionPools(l3item.questionPools) }}</td>
                        <td>{{ vm.FORMS_CATEGORY_QUESTION_ENUM.LABELS[l3item.status] }}</td>
                        <td class="actions">
                            <a class="btn add" ng-click="vm.addSubCategory(l3item.id)">{{ 'questionCategory.Add subcategory' | translate }}</a>
                            <a class="btn edit" ui-sref="authorized.forms.settings.questioncategories.edit({ id: l3item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deleteCategory(l3item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-start="l4item in l3item.childCategories" class="level04" ng-class="{status04: l4item.status === vm.FORMS_CATEGORY_QUESTION_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.questioncategories.edit({ id: l4item.id })">{{ l4item.activeI18n.name }}</td>
                        <td>{{ l4item.questionCount }}</td>
                        <td>{{ vm.getQuestionPools(l4item.questionPools) }}</td>
                        <td>{{ vm.FORMS_CATEGORY_QUESTION_ENUM.LABELS[l4item.status] }}</td>
                        <td class="actions" style="text-align: right">
                            <a class="btn edit" ui-sref="authorized.forms.settings.questioncategories.edit({ id: l4item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deleteCategory(l4item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td></tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    </div>
    `
})
export default class {
    constructor ($translate, lodash, ListFactory, ModalService, QuestionService, QuestionCategoryResource, DATATABLES, FORMS_CATEGORY_QUESTION_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.QuestionCategoryResource = QuestionCategoryResource;
        this.DATATABLES = DATATABLES;
        this.FORMS_CATEGORY_QUESTION_ENUM = FORMS_CATEGORY_QUESTION_ENUM;
        this.ModalService = ModalService;
        this.QuestionService = QuestionService;
        this.list = ListFactory.createWithPagination(QuestionCategoryResource.tree.bind(QuestionCategoryResource));
        this.list.fetch();
    }

    addCategory () {
        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-settings-questioncategories-add ok="vm.$uibModalInstance.close()" cancel="vm.$uibModalInstance.dismiss()"></forms-settings-questioncategories-add>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => {
            this.list.fetch();
        });
    }

    addSubCategory (parentCategoryId) {
        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-settings-questionsubcategories-add ok="vm.$uibModalInstance.close()" cancel="vm.$uibModalInstance.dismiss()" parent-category-id="vm.parentCategoryId"/>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.parentCategoryId = parentCategoryId;
            }
        }).then(() => {
            this.list.fetch();
        });
    }

    deleteCategory (id) {
        this.ModalService.confirm(
            this.$translate.instant('questionCategory.Are you sure you want to delete this category? Subcategories will be also deleted')
            , 'large'
        ).then(() => {
            this.QuestionCategoryResource.delete({ id }).$promise.then(() => {
                this.list.fetch();
            });
        });
    }

    getQuestionPools (questionPools) {
        const poolNames = this.lodash.reduce(questionPools, (origin, pool) => {
            origin.push(pool.name);
            return origin;
        }, []);
        return poolNames.join(', ');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/questioncategories/list/index.js